// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import CaseAnybound from "./CaseAnybound";
import CaseAssetSim from "./CaseAssetSim";
import CaseDefi from "./CaseDefi";
import CaseEhon from "./CaseEhon";
import CaseHikky from "./CaseHikky";
import CaseKandaCurry from "./CaseKandaCurry";
import CaseKidsArt from "./CaseKidsArt";
import CaseNasushiobara from "./CaseNasushiobara";
import CasePizzaday from "./CasePizzaday";
import CasePremience from "./CasePremience";
import CaseTcg from "./CaseTcg";

// slug → 詳細ページの本文
export const CASE_BODIES = {
  "anybound": CaseAnybound,
  "kanda-curry": CaseKandaCurry,
  "premience": CasePremience,
  "hikky": CaseHikky,
  "ehon": CaseEhon,
  "pizzaday": CasePizzaday,
  "nasushiobara": CaseNasushiobara,
  "kids-art": CaseKidsArt,
  "tcg": CaseTcg,
  "asset-sim": CaseAssetSim,
  "defi": CaseDefi,
};
